"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var redux_1 = require("redux");
var history_1 = require("history");
var connected_react_router_1 = require("connected-react-router");
var redux_saga_1 = __importDefault(require("redux-saga"));
var i18n_1 = require("Service/i18n");
var router_1 = __importDefault(require("./router"));
var reducers_1 = __importDefault(require("./redux/reducers"));
var sagas_1 = __importDefault(require("./redux/sagas"));
var context_1 = __importDefault(require("App/context"));
// import { logger } from 'redux-logger'
// middlewared
var history = history_1.createBrowserHistory({});
var sagaMiddleware = redux_saga_1.default();
var routeMiddleware = connected_react_router_1.routerMiddleware(history);
var middlewares = [sagaMiddleware, routeMiddleware];
var AdobeWorkfrontApp = function (_a) {
    var name = _a.name, logoBase64 = _a.logoBase64, logoMimeType = _a.logoMimeType, languages = _a.languages, redux = _a.redux, router = _a.router, _b = _a.showBreadcrumb, showBreadcrumb = _b === void 0 ? true : _b, _c = _a.hideTenantSwitch, hideTenantSwitch = _c === void 0 ? false : _c;
    i18n_1.loadI18Next(languages);
    var store = redux_1.createStore(reducers_1.default(history, redux === null || redux === void 0 ? void 0 : redux.reducers), redux_1.compose(redux_1.applyMiddleware.apply(void 0, middlewares)));
    sagaMiddleware.run(sagas_1.default, redux === null || redux === void 0 ? void 0 : redux.sagas);
    return (react_1.default.createElement(react_redux_1.Provider, { store: store },
        react_1.default.createElement(context_1.default, { pages: router.pages || [], name: name, logoBase64: logoBase64, logoMimeType: logoMimeType, showBreadcrumb: showBreadcrumb, hideTenantSwitch: true },
            react_1.default.createElement(router_1.default, { history: history, indexUrl: router.indexUrl, pages: router.pages }))));
};
exports.default = AdobeWorkfrontApp;
//# sourceMappingURL=index.js.map